<template>
  <el-dialog
    top="15vh"
    class="agent-edit__dialog"
    :title="row.id ? '编辑代理商' : '新增代理商'"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="130px"
      size="small"
      label-suffix=": "
    >
      <el-form-item label="所属经销商" prop="distributorId">
        <Select
          :query="$api.channel.distributor_select"
          v-model="form.distributorId"
          placeholder="请选择"
          :disabled="!!row.id"
        >
        </Select>
      </el-form-item>
      <el-form-item label="代理商名称" prop="name">
        <el-input
          autocomplete="new-account"
          v-model="form.name"
          placeholder="最多16个字符"
          :maxlength="16"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="所在地址" prop="address">
        <Address ref="address" v-model="area" width="232px" />
        <el-input
          type="textarea"
          :rows="3"
          style="margin-top:8px;width:340px;"
          v-model="form.address"
          placeholder="详细地址"
          :maxlength="30"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item label="代理产品" prop="productKey">
        <Select
          multiple
          :query="$api.product.product_select"
          v-model="form.productKey"
          placeholder="请选择"
        >
        </Select>
      </el-form-item>
      <el-form-item label="负责人" prop="principal">
        <el-input v-model="form.principal" placeholder="最多16个字符" :maxlength="16"> </el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" placeholder="联系电话"> </el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="邮箱" :maxlength="30"> </el-input>
      </el-form-item>
      <el-form-item label="有效期至" prop="expiryDate">
        <el-date-picker
          v-model="form.expiryDate"
          type="date"
          placeholder="有效期至"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="系统管理员账号" prop="account">
        <el-input
          v-model="form.account"
          placeholder="最多16个字符"
          :maxlength="16"
          :disabled="!!row.id"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" v-if="!row.id">
        <el-input v-model="form.password" placeholder="请输入" :maxlength="16"> </el-input>
      </el-form-item>
      <el-form-item label="角色选择" prop="roleId">
        <Select :query="$api.system.role_select" v-model="form.roleId" placeholder="角色选择">
        </Select>
      </el-form-item>
      <el-form-item label="是否启用" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio label="ENABLE">启用</el-radio>
          <el-radio label="DISABLED">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">取消</hl-button>
      <hl-button @click="save" :loading="loading">保存</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import Address from '@/components/CommonForm/Address'
import Select from '@/components/CommonForm/Select'
import { phoneReg, emailReg } from '@/utils/regex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select,
    Address
  },
  data() {
    let validateAddress = (rule, value, callback) => {
      if (!this.area[0]) {
        callback(new Error('请选择省'))
      } else if (!this.form.address) {
        callback(new Error('请填写地址'))
      } else {
        callback()
      }
    }
    let validatephone = (rule, value, callback) => {
      if (!this.form.phone) {
        callback(new Error('请输入联系电话'))
      } else if (!phoneReg.test(this.form.phone)) {
        callback(new Error('请输入正确格式手机号'))
      } else {
        callback()
      }
    }
    let validateemail = (rule, value, callback) => {
      if (this.form.email !== '' && !emailReg.test(this.form.email)) {
        callback(new Error('请输入正确格式邮箱'))
      } else {
        callback()
      }
    }
    return {
      form: {
        status: 'ENABLE',
        roleId: '',
        email: ''
      },
      rules: {
        name: [{ required: true, message: '请输入经销商名称', trigger: 'blur' }],
        address: [{ required: true, validator: validateAddress, trigger: 'blur' }],
        phone: [{ required: true, validator: validatephone, trigger: 'blur' }],
        email: [{ validator: validateemail, trigger: 'blur' }],
        account: [{ required: true, message: '请输入系统管理员账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      area: [],
      loading: false
    }
  },
  created() {
    if (this.row.id) {
      this.queryDetail()
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    queryDetail() {
      const params = {
        id: this.row.id
      }
      this.$ajax
        .get(this.$api.channel.agent_detail, params)
        .then((res) => {
          if (res.data) {
            this.area = [res.data.province, res.data.city, res.data.region].filter(Boolean)
            this.form = res.data
            this.form.expiryDate = new Date(res.data.expiryDate)
            this.form.productKey = res.data.productList
              ? res.data.productList.map((item) => item.productKey)
              : []
          }
        })
        .catch(() => {})
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        id: this.row.id,
        name: this.form.name,
        distributorId: this.form.distributorId,
        address: this.form.address,
        province: this.area[0],
        city: this.area[1] || '',
        region: this.area[2] || '',
        productKey: this.form.productKey ? this.form.productKey.join(',') : '',
        principal: this.form.principal,
        phone: this.form.phone,
        email: this.form.email,
        expiryDate: this.form.expiryDate,
        account: this.form.account,
        password: this.row.id ? undefined : this.form.password,
        roleId: this.form.roleId,
        status: this.form.status
      }
      let api = this.row.id ? this.$api.channel.agent_update : this.$api.channel.agent_add
      this.$ajax
        .post(api, params)
        .then(() => {
          this.$message.success(`${this.row.id ? '修改代理商成功' : '新增代理商成功'}`)
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.agent-edit__dialog {
  /deep/.el-dialog__body {
    padding-left: 30px;
  }
}
</style>
